import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TreeMaintenanceTableDefinition } from '@compiere-ws/models/apiz-domains';
import { AppConfig } from '@iupics-config/app.config.service';
import { DataStoreService } from '@iupics-manager/managers/data-store/data-store.service';
import { Observable } from 'rxjs';

@Injectable()
export class TreeMaintenanceService {
  http = inject(HttpClient);
  config = inject(AppConfig);
  store = inject(DataStoreService);

  tableDefURL = this.config.getBackendResource('treeMaintenanceTableDef');

  getTreeMaintenanceTableDefinition(treeId: number): Observable<TreeMaintenanceTableDefinition> {
    return this.http.get(this.tableDefURL + '/' + treeId);
  }
}
